import { Request } from '@/helpers'
import { ENDPOINTS } from '@/data'

const List = async (SetState: Function, push: Function) => {
    SetState({
        Categories: [],
        Loading: true
    })

    const { success, data } = await Request({
        path: ENDPOINTS.LIST_CATEGORIES,
        method: 'GET'
    })

    if (success) SetState({
        Categories: data,
        Loading: false
    })
}

export default List
